import { SPECIAL_CHARACTERS_INPUT } from '../Utils/Constants';

export const handleServerError = (error) => {


  if (error) {
    if (error.response) {
      if (error.response.status && error.response.status === 401)
        setTimeout(() => {
            window.location.reload();
        }, 1000)

      if (error.response.data) {
        if (error.response.data.Message) {
          return error.response.data.Message
        }
        return error.response.data;
      }

    }

    if (typeof error === 'string')
      return error;

    if (error instanceof Error) {
      return error.message;
    }
  }

  return 'The server returned a negative response without any message associated.';
}

export const handleSpecialCharacters = (value) => {
  if (isNaN(value)) {
    return value.replace(SPECIAL_CHARACTERS_INPUT, '');
  } 

  return value;
}


// WEBPACK FOOTER //
// ./src/Utils/Helper.js